import { render, staticRenderFns } from "./ExamEnablerTable.vue?vue&type=template&id=2ab2054c&scoped=true"
import script from "./ExamEnablerTable.vue?vue&type=script&lang=js"
export * from "./ExamEnablerTable.vue?vue&type=script&lang=js"
import style0 from "./ExamEnablerTable.vue?vue&type=style&index=0&id=2ab2054c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab2054c",
  null
  
)

export default component.exports